/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RubricConvertUseAtv2EnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('RUBRIC_CONVERT_USE_ATV2_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class RubricConvertUseAtv2EnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RubricConvertUseAtv2EnabledSettingParser.decode(input).map(res => new RubricConvertUseAtv2EnabledSetting(res));
    }
    static unsafeDecode(input) {
        return RubricConvertUseAtv2EnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricConvertUseAtv2EnabledSettingParser.encode(data);
    }
    static schema() {
        return RubricConvertUseAtv2EnabledSettingParser.schema();
    }
}
